import { Tabs } from 'antd';
import PlantationsVerifyView from './PlantationsVerifyView';
import PlantationsListView from './PlantationsListView';
import { FileSearchOutlined, FolderOpenOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import URLTabs from '../components/common/URLTabs';

export default function PlantationManagerView() {
  const { t, } = useTranslation();

  return (
    <div>
      <URLTabs
        defaultActiveKey='#pending'
        destroyInactiveTabPane={true}
        items={[
          {
            key: "#pending", 
            label: <span><FileSearchOutlined />{t("plantations.pending_review")}</span>, 
            children: <PlantationsVerifyView />,
          },
          {
            key: "#all", 
            label: <span><FolderOpenOutlined />{t("plantations.all_plantation")}</span>, 
            children: <PlantationsListView />,
          }
        ]}
      />
    </div>
  )
}